/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as R404RouteImport } from './routes/404'
import { Route as CategoriesRouteRouteImport } from './routes/categories.route'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DocumentsRouteRouteImport } from './routes/documents.route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as NotAuthorizedRouteImport } from './routes/not-authorized'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ApprovalsIndexRouteImport } from './routes/approvals/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as CategoriesIndexRouteImport } from './routes/categories/index'
import { Route as CategoriesPathlessLayoutRouteImport } from './routes/categories/_pathlessLayout'
import { Route as DevPermissionsRouteImport } from './routes/dev/permissions'
import { Route as DocumentsIndexRouteImport } from './routes/documents/index'
import { Route as LogsIndexRouteImport } from './routes/logs/index'
import { Route as NotificationsIndexRouteImport } from './routes/notifications/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsNewRouteImport } from './routes/projects/new'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as TemplatesNewRouteImport } from './routes/templates/new'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as UsersInviteRouteImport } from './routes/users/invite'
import { Route as UsersRolesRouteRouteImport } from './routes/users/roles.route'
import { Route as CategoriesPathlessLayoutAreasRouteImport } from './routes/categories/_pathlessLayout.areas'
import { Route as CategoriesPathlessLayoutDepartmentsRouteImport } from './routes/categories/_pathlessLayout.departments'
import { Route as CategoriesPathlessLayoutRegionsRouteImport } from './routes/categories/_pathlessLayout.regions'
import { Route as LegalDocumentsApprovalsIndexRouteImport } from './routes/legal-documents/approvals/index'
import { Route as LegalDocumentsTasksIndexRouteImport } from './routes/legal-documents/tasks/index'
import { Route as ProjectsIdPathlessLayoutRouteImport } from './routes/projects/$id/_pathlessLayout'
import { Route as TemplatesIdEditRouteImport } from './routes/templates/$id/edit'
import { Route as UsersRolesIndexRouteImport } from './routes/users/roles/index'
import { Route as UsersRolesNewRouteImport } from './routes/users/roles/new'
import { Route as CategoriesPathlessLayoutIdIndexRouteImport } from './routes/categories/_pathlessLayout.$id/index'
import { Route as ProjectsIdPathlessLayoutIndexRouteImport } from './routes/projects/$id/_pathlessLayout.index'
import { Route as ProjectsIdPathlessLayoutPermissionsRouteImport } from './routes/projects/$id/_pathlessLayout.permissions'
import { Route as ProjectsIdPathlessLayoutProjectProfileRouteImport } from './routes/projects/$id/_pathlessLayout.project-profile'
import { Route as ProjectsIdPathlessLayoutTasksRouteImport } from './routes/projects/$id/_pathlessLayout.tasks'
import { Route as UsersRolesIdEditRouteImport } from './routes/users/roles/$id/edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesRouteRoute = CategoriesRouteRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsRouteRoute = DocumentsRouteRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const NotAuthorizedRoute = NotAuthorizedRouteImport.update({
  id: '/not-authorized',
  path: '/not-authorized',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsIndexRoute = ApprovalsIndexRouteImport.update({
  id: '/approvals/',
  path: '/approvals/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesIndexRoute = CategoriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CategoriesRouteRoute,
} as any)
const CategoriesPathlessLayoutRoute =
  CategoriesPathlessLayoutRouteImport.update({
    id: '/_pathlessLayout',
    getParentRoute: () => CategoriesRouteRoute,
  } as any)
const DevPermissionsRoute = DevPermissionsRouteImport.update({
  id: '/dev/permissions',
  path: '/dev/permissions',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsIndexRoute = DocumentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocumentsRouteRoute,
} as any)
const LogsIndexRoute = LogsIndexRouteImport.update({
  id: '/logs/',
  path: '/logs/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesNewRoute = TemplatesNewRouteImport.update({
  id: '/templates/new',
  path: '/templates/new',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersInviteRoute = UsersInviteRouteImport.update({
  id: '/users/invite',
  path: '/users/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRolesRouteRoute = UsersRolesRouteRouteImport.update({
  id: '/users/roles',
  path: '/users/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesPathlessLayoutAreasRoute =
  CategoriesPathlessLayoutAreasRouteImport.update({
    id: '/areas',
    path: '/areas',
    getParentRoute: () => CategoriesPathlessLayoutRoute,
  } as any)
const CategoriesPathlessLayoutDepartmentsRoute =
  CategoriesPathlessLayoutDepartmentsRouteImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => CategoriesPathlessLayoutRoute,
  } as any)
const CategoriesPathlessLayoutRegionsRoute =
  CategoriesPathlessLayoutRegionsRouteImport.update({
    id: '/regions',
    path: '/regions',
    getParentRoute: () => CategoriesPathlessLayoutRoute,
  } as any)
const LegalDocumentsApprovalsIndexRoute =
  LegalDocumentsApprovalsIndexRouteImport.update({
    id: '/legal-documents/approvals/',
    path: '/legal-documents/approvals/',
    getParentRoute: () => rootRouteImport,
  } as any)
const LegalDocumentsTasksIndexRoute =
  LegalDocumentsTasksIndexRouteImport.update({
    id: '/legal-documents/tasks/',
    path: '/legal-documents/tasks/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsIdPathlessLayoutRoute =
  ProjectsIdPathlessLayoutRouteImport.update({
    id: '/projects/$id/_pathlessLayout',
    path: '/projects/$id',
    getParentRoute: () => rootRouteImport,
  } as any)
const TemplatesIdEditRoute = TemplatesIdEditRouteImport.update({
  id: '/templates/$id/edit',
  path: '/templates/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRolesIndexRoute = UsersRolesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UsersRolesRouteRoute,
} as any)
const UsersRolesNewRoute = UsersRolesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => UsersRolesRouteRoute,
} as any)
const CategoriesPathlessLayoutIdIndexRoute =
  CategoriesPathlessLayoutIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => CategoriesPathlessLayoutRoute,
  } as any)
const ProjectsIdPathlessLayoutIndexRoute =
  ProjectsIdPathlessLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProjectsIdPathlessLayoutRoute,
  } as any)
const ProjectsIdPathlessLayoutPermissionsRoute =
  ProjectsIdPathlessLayoutPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => ProjectsIdPathlessLayoutRoute,
  } as any)
const ProjectsIdPathlessLayoutProjectProfileRoute =
  ProjectsIdPathlessLayoutProjectProfileRouteImport.update({
    id: '/project-profile',
    path: '/project-profile',
    getParentRoute: () => ProjectsIdPathlessLayoutRoute,
  } as any)
const ProjectsIdPathlessLayoutTasksRoute =
  ProjectsIdPathlessLayoutTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => ProjectsIdPathlessLayoutRoute,
  } as any)
const UsersRolesIdEditRoute = UsersRolesIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => UsersRolesRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/categories': typeof CategoriesRouteRouteWithChildren
  '/documents': typeof DocumentsRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/not-authorized': typeof NotAuthorizedRoute
  '/products': typeof ProductsRoute
  '/profile': typeof ProfileRoute
  '/settings': typeof SettingsRoute
  '/users/roles': typeof UsersRolesRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/dev/permissions': typeof DevPermissionsRoute
  '/projects/new': typeof ProjectsNewRoute
  '/templates/new': typeof TemplatesNewRoute
  '/users/invite': typeof UsersInviteRoute
  '/approvals/': typeof ApprovalsIndexRoute
  '/categories/': typeof CategoriesIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/logs/': typeof LogsIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/users/': typeof UsersIndexRoute
  '/categories/areas': typeof CategoriesPathlessLayoutAreasRoute
  '/categories/departments': typeof CategoriesPathlessLayoutDepartmentsRoute
  '/categories/regions': typeof CategoriesPathlessLayoutRegionsRoute
  '/projects/$id': typeof ProjectsIdPathlessLayoutRouteWithChildren
  '/templates/$id/edit': typeof TemplatesIdEditRoute
  '/users/roles/new': typeof UsersRolesNewRoute
  '/legal-documents/approvals/': typeof LegalDocumentsApprovalsIndexRoute
  '/legal-documents/tasks/': typeof LegalDocumentsTasksIndexRoute
  '/users/roles/': typeof UsersRolesIndexRoute
  '/projects/$id/permissions': typeof ProjectsIdPathlessLayoutPermissionsRoute
  '/projects/$id/project-profile': typeof ProjectsIdPathlessLayoutProjectProfileRoute
  '/projects/$id/tasks': typeof ProjectsIdPathlessLayoutTasksRoute
  '/users/roles/$id/edit': typeof UsersRolesIdEditRoute
  '/categories/$id/': typeof CategoriesPathlessLayoutIdIndexRoute
  '/projects/$id/': typeof ProjectsIdPathlessLayoutIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/not-authorized': typeof NotAuthorizedRoute
  '/products': typeof ProductsRoute
  '/profile': typeof ProfileRoute
  '/settings': typeof SettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/categories': typeof CategoriesIndexRoute
  '/dev/permissions': typeof DevPermissionsRoute
  '/projects/new': typeof ProjectsNewRoute
  '/templates/new': typeof TemplatesNewRoute
  '/users/invite': typeof UsersInviteRoute
  '/approvals': typeof ApprovalsIndexRoute
  '/documents': typeof DocumentsIndexRoute
  '/logs': typeof LogsIndexRoute
  '/notifications': typeof NotificationsIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/users': typeof UsersIndexRoute
  '/categories/areas': typeof CategoriesPathlessLayoutAreasRoute
  '/categories/departments': typeof CategoriesPathlessLayoutDepartmentsRoute
  '/categories/regions': typeof CategoriesPathlessLayoutRegionsRoute
  '/templates/$id/edit': typeof TemplatesIdEditRoute
  '/users/roles/new': typeof UsersRolesNewRoute
  '/legal-documents/approvals': typeof LegalDocumentsApprovalsIndexRoute
  '/legal-documents/tasks': typeof LegalDocumentsTasksIndexRoute
  '/users/roles': typeof UsersRolesIndexRoute
  '/projects/$id/permissions': typeof ProjectsIdPathlessLayoutPermissionsRoute
  '/projects/$id/project-profile': typeof ProjectsIdPathlessLayoutProjectProfileRoute
  '/projects/$id/tasks': typeof ProjectsIdPathlessLayoutTasksRoute
  '/users/roles/$id/edit': typeof UsersRolesIdEditRoute
  '/categories/$id': typeof CategoriesPathlessLayoutIdIndexRoute
  '/projects/$id': typeof ProjectsIdPathlessLayoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/categories': typeof CategoriesRouteRouteWithChildren
  '/documents': typeof DocumentsRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/maintenance': typeof MaintenanceRoute
  '/not-authorized': typeof NotAuthorizedRoute
  '/products': typeof ProductsRoute
  '/profile': typeof ProfileRoute
  '/settings': typeof SettingsRoute
  '/users/roles': typeof UsersRolesRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/categories/_pathlessLayout': typeof CategoriesPathlessLayoutRouteWithChildren
  '/dev/permissions': typeof DevPermissionsRoute
  '/projects/new': typeof ProjectsNewRoute
  '/templates/new': typeof TemplatesNewRoute
  '/users/invite': typeof UsersInviteRoute
  '/approvals/': typeof ApprovalsIndexRoute
  '/categories/': typeof CategoriesIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/logs/': typeof LogsIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/users/': typeof UsersIndexRoute
  '/categories/_pathlessLayout/areas': typeof CategoriesPathlessLayoutAreasRoute
  '/categories/_pathlessLayout/departments': typeof CategoriesPathlessLayoutDepartmentsRoute
  '/categories/_pathlessLayout/regions': typeof CategoriesPathlessLayoutRegionsRoute
  '/projects/$id/_pathlessLayout': typeof ProjectsIdPathlessLayoutRouteWithChildren
  '/templates/$id/edit': typeof TemplatesIdEditRoute
  '/users/roles/new': typeof UsersRolesNewRoute
  '/legal-documents/approvals/': typeof LegalDocumentsApprovalsIndexRoute
  '/legal-documents/tasks/': typeof LegalDocumentsTasksIndexRoute
  '/users/roles/': typeof UsersRolesIndexRoute
  '/projects/$id/_pathlessLayout/permissions': typeof ProjectsIdPathlessLayoutPermissionsRoute
  '/projects/$id/_pathlessLayout/project-profile': typeof ProjectsIdPathlessLayoutProjectProfileRoute
  '/projects/$id/_pathlessLayout/tasks': typeof ProjectsIdPathlessLayoutTasksRoute
  '/users/roles/$id/edit': typeof UsersRolesIdEditRoute
  '/categories/_pathlessLayout/$id/': typeof CategoriesPathlessLayoutIdIndexRoute
  '/projects/$id/_pathlessLayout/': typeof ProjectsIdPathlessLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/categories'
    | '/documents'
    | '/$'
    | '/404'
    | '/dashboard'
    | '/login'
    | '/maintenance'
    | '/not-authorized'
    | '/products'
    | '/profile'
    | '/settings'
    | '/users/roles'
    | '/auth/callback'
    | '/dev/permissions'
    | '/projects/new'
    | '/templates/new'
    | '/users/invite'
    | '/approvals/'
    | '/categories/'
    | '/documents/'
    | '/logs/'
    | '/notifications/'
    | '/projects/'
    | '/templates/'
    | '/users/'
    | '/categories/areas'
    | '/categories/departments'
    | '/categories/regions'
    | '/projects/$id'
    | '/templates/$id/edit'
    | '/users/roles/new'
    | '/legal-documents/approvals/'
    | '/legal-documents/tasks/'
    | '/users/roles/'
    | '/projects/$id/permissions'
    | '/projects/$id/project-profile'
    | '/projects/$id/tasks'
    | '/users/roles/$id/edit'
    | '/categories/$id/'
    | '/projects/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/404'
    | '/dashboard'
    | '/login'
    | '/maintenance'
    | '/not-authorized'
    | '/products'
    | '/profile'
    | '/settings'
    | '/auth/callback'
    | '/categories'
    | '/dev/permissions'
    | '/projects/new'
    | '/templates/new'
    | '/users/invite'
    | '/approvals'
    | '/documents'
    | '/logs'
    | '/notifications'
    | '/projects'
    | '/templates'
    | '/users'
    | '/categories/areas'
    | '/categories/departments'
    | '/categories/regions'
    | '/templates/$id/edit'
    | '/users/roles/new'
    | '/legal-documents/approvals'
    | '/legal-documents/tasks'
    | '/users/roles'
    | '/projects/$id/permissions'
    | '/projects/$id/project-profile'
    | '/projects/$id/tasks'
    | '/users/roles/$id/edit'
    | '/categories/$id'
    | '/projects/$id'
  id:
    | '__root__'
    | '/'
    | '/categories'
    | '/documents'
    | '/$'
    | '/404'
    | '/dashboard'
    | '/login'
    | '/maintenance'
    | '/not-authorized'
    | '/products'
    | '/profile'
    | '/settings'
    | '/users/roles'
    | '/auth/callback'
    | '/categories/_pathlessLayout'
    | '/dev/permissions'
    | '/projects/new'
    | '/templates/new'
    | '/users/invite'
    | '/approvals/'
    | '/categories/'
    | '/documents/'
    | '/logs/'
    | '/notifications/'
    | '/projects/'
    | '/templates/'
    | '/users/'
    | '/categories/_pathlessLayout/areas'
    | '/categories/_pathlessLayout/departments'
    | '/categories/_pathlessLayout/regions'
    | '/projects/$id/_pathlessLayout'
    | '/templates/$id/edit'
    | '/users/roles/new'
    | '/legal-documents/approvals/'
    | '/legal-documents/tasks/'
    | '/users/roles/'
    | '/projects/$id/_pathlessLayout/permissions'
    | '/projects/$id/_pathlessLayout/project-profile'
    | '/projects/$id/_pathlessLayout/tasks'
    | '/users/roles/$id/edit'
    | '/categories/_pathlessLayout/$id/'
    | '/projects/$id/_pathlessLayout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CategoriesRouteRoute: typeof CategoriesRouteRouteWithChildren
  DocumentsRouteRoute: typeof DocumentsRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  R404Route: typeof R404Route
  DashboardRoute: typeof DashboardRoute
  LoginRoute: typeof LoginRoute
  MaintenanceRoute: typeof MaintenanceRoute
  NotAuthorizedRoute: typeof NotAuthorizedRoute
  ProductsRoute: typeof ProductsRoute
  ProfileRoute: typeof ProfileRoute
  SettingsRoute: typeof SettingsRoute
  UsersRolesRouteRoute: typeof UsersRolesRouteRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  DevPermissionsRoute: typeof DevPermissionsRoute
  ProjectsNewRoute: typeof ProjectsNewRoute
  TemplatesNewRoute: typeof TemplatesNewRoute
  UsersInviteRoute: typeof UsersInviteRoute
  ApprovalsIndexRoute: typeof ApprovalsIndexRoute
  LogsIndexRoute: typeof LogsIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  ProjectsIdPathlessLayoutRoute: typeof ProjectsIdPathlessLayoutRouteWithChildren
  TemplatesIdEditRoute: typeof TemplatesIdEditRoute
  LegalDocumentsApprovalsIndexRoute: typeof LegalDocumentsApprovalsIndexRoute
  LegalDocumentsTasksIndexRoute: typeof LegalDocumentsTasksIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories': {
      id: '/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof CategoriesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents': {
      id: '/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DocumentsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-authorized': {
      id: '/not-authorized'
      path: '/not-authorized'
      fullPath: '/not-authorized'
      preLoaderRoute: typeof NotAuthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals/': {
      id: '/approvals/'
      path: '/approvals'
      fullPath: '/approvals/'
      preLoaderRoute: typeof ApprovalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories/': {
      id: '/categories/'
      path: '/'
      fullPath: '/categories/'
      preLoaderRoute: typeof CategoriesIndexRouteImport
      parentRoute: typeof CategoriesRouteRoute
    }
    '/categories/_pathlessLayout': {
      id: '/categories/_pathlessLayout'
      path: ''
      fullPath: '/categories'
      preLoaderRoute: typeof CategoriesPathlessLayoutRouteImport
      parentRoute: typeof CategoriesRouteRoute
    }
    '/dev/permissions': {
      id: '/dev/permissions'
      path: '/dev/permissions'
      fullPath: '/dev/permissions'
      preLoaderRoute: typeof DevPermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/': {
      id: '/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof DocumentsIndexRouteImport
      parentRoute: typeof DocumentsRouteRoute
    }
    '/logs/': {
      id: '/logs/'
      path: '/logs'
      fullPath: '/logs/'
      preLoaderRoute: typeof LogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/': {
      id: '/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/new': {
      id: '/templates/new'
      path: '/templates/new'
      fullPath: '/templates/new'
      preLoaderRoute: typeof TemplatesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/invite': {
      id: '/users/invite'
      path: '/users/invite'
      fullPath: '/users/invite'
      preLoaderRoute: typeof UsersInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/roles': {
      id: '/users/roles'
      path: '/users/roles'
      fullPath: '/users/roles'
      preLoaderRoute: typeof UsersRolesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories/_pathlessLayout/areas': {
      id: '/categories/_pathlessLayout/areas'
      path: '/areas'
      fullPath: '/categories/areas'
      preLoaderRoute: typeof CategoriesPathlessLayoutAreasRouteImport
      parentRoute: typeof CategoriesPathlessLayoutRoute
    }
    '/categories/_pathlessLayout/departments': {
      id: '/categories/_pathlessLayout/departments'
      path: '/departments'
      fullPath: '/categories/departments'
      preLoaderRoute: typeof CategoriesPathlessLayoutDepartmentsRouteImport
      parentRoute: typeof CategoriesPathlessLayoutRoute
    }
    '/categories/_pathlessLayout/regions': {
      id: '/categories/_pathlessLayout/regions'
      path: '/regions'
      fullPath: '/categories/regions'
      preLoaderRoute: typeof CategoriesPathlessLayoutRegionsRouteImport
      parentRoute: typeof CategoriesPathlessLayoutRoute
    }
    '/legal-documents/approvals/': {
      id: '/legal-documents/approvals/'
      path: '/legal-documents/approvals'
      fullPath: '/legal-documents/approvals/'
      preLoaderRoute: typeof LegalDocumentsApprovalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal-documents/tasks/': {
      id: '/legal-documents/tasks/'
      path: '/legal-documents/tasks'
      fullPath: '/legal-documents/tasks/'
      preLoaderRoute: typeof LegalDocumentsTasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id/_pathlessLayout': {
      id: '/projects/$id/_pathlessLayout'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof ProjectsIdPathlessLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/$id/edit': {
      id: '/templates/$id/edit'
      path: '/templates/$id/edit'
      fullPath: '/templates/$id/edit'
      preLoaderRoute: typeof TemplatesIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/roles/': {
      id: '/users/roles/'
      path: '/'
      fullPath: '/users/roles/'
      preLoaderRoute: typeof UsersRolesIndexRouteImport
      parentRoute: typeof UsersRolesRouteRoute
    }
    '/users/roles/new': {
      id: '/users/roles/new'
      path: '/new'
      fullPath: '/users/roles/new'
      preLoaderRoute: typeof UsersRolesNewRouteImport
      parentRoute: typeof UsersRolesRouteRoute
    }
    '/categories/_pathlessLayout/$id/': {
      id: '/categories/_pathlessLayout/$id/'
      path: '/$id'
      fullPath: '/categories/$id/'
      preLoaderRoute: typeof CategoriesPathlessLayoutIdIndexRouteImport
      parentRoute: typeof CategoriesPathlessLayoutRoute
    }
    '/projects/$id/_pathlessLayout/': {
      id: '/projects/$id/_pathlessLayout/'
      path: '/'
      fullPath: '/projects/$id/'
      preLoaderRoute: typeof ProjectsIdPathlessLayoutIndexRouteImport
      parentRoute: typeof ProjectsIdPathlessLayoutRoute
    }
    '/projects/$id/_pathlessLayout/permissions': {
      id: '/projects/$id/_pathlessLayout/permissions'
      path: '/permissions'
      fullPath: '/projects/$id/permissions'
      preLoaderRoute: typeof ProjectsIdPathlessLayoutPermissionsRouteImport
      parentRoute: typeof ProjectsIdPathlessLayoutRoute
    }
    '/projects/$id/_pathlessLayout/project-profile': {
      id: '/projects/$id/_pathlessLayout/project-profile'
      path: '/project-profile'
      fullPath: '/projects/$id/project-profile'
      preLoaderRoute: typeof ProjectsIdPathlessLayoutProjectProfileRouteImport
      parentRoute: typeof ProjectsIdPathlessLayoutRoute
    }
    '/projects/$id/_pathlessLayout/tasks': {
      id: '/projects/$id/_pathlessLayout/tasks'
      path: '/tasks'
      fullPath: '/projects/$id/tasks'
      preLoaderRoute: typeof ProjectsIdPathlessLayoutTasksRouteImport
      parentRoute: typeof ProjectsIdPathlessLayoutRoute
    }
    '/users/roles/$id/edit': {
      id: '/users/roles/$id/edit'
      path: '/$id/edit'
      fullPath: '/users/roles/$id/edit'
      preLoaderRoute: typeof UsersRolesIdEditRouteImport
      parentRoute: typeof UsersRolesRouteRoute
    }
  }
}

interface CategoriesPathlessLayoutRouteChildren {
  CategoriesPathlessLayoutAreasRoute: typeof CategoriesPathlessLayoutAreasRoute
  CategoriesPathlessLayoutDepartmentsRoute: typeof CategoriesPathlessLayoutDepartmentsRoute
  CategoriesPathlessLayoutRegionsRoute: typeof CategoriesPathlessLayoutRegionsRoute
  CategoriesPathlessLayoutIdIndexRoute: typeof CategoriesPathlessLayoutIdIndexRoute
}

const CategoriesPathlessLayoutRouteChildren: CategoriesPathlessLayoutRouteChildren =
  {
    CategoriesPathlessLayoutAreasRoute: CategoriesPathlessLayoutAreasRoute,
    CategoriesPathlessLayoutDepartmentsRoute:
      CategoriesPathlessLayoutDepartmentsRoute,
    CategoriesPathlessLayoutRegionsRoute: CategoriesPathlessLayoutRegionsRoute,
    CategoriesPathlessLayoutIdIndexRoute: CategoriesPathlessLayoutIdIndexRoute,
  }

const CategoriesPathlessLayoutRouteWithChildren =
  CategoriesPathlessLayoutRoute._addFileChildren(
    CategoriesPathlessLayoutRouteChildren,
  )

interface CategoriesRouteRouteChildren {
  CategoriesPathlessLayoutRoute: typeof CategoriesPathlessLayoutRouteWithChildren
  CategoriesIndexRoute: typeof CategoriesIndexRoute
}

const CategoriesRouteRouteChildren: CategoriesRouteRouteChildren = {
  CategoriesPathlessLayoutRoute: CategoriesPathlessLayoutRouteWithChildren,
  CategoriesIndexRoute: CategoriesIndexRoute,
}

const CategoriesRouteRouteWithChildren = CategoriesRouteRoute._addFileChildren(
  CategoriesRouteRouteChildren,
)

interface DocumentsRouteRouteChildren {
  DocumentsIndexRoute: typeof DocumentsIndexRoute
}

const DocumentsRouteRouteChildren: DocumentsRouteRouteChildren = {
  DocumentsIndexRoute: DocumentsIndexRoute,
}

const DocumentsRouteRouteWithChildren = DocumentsRouteRoute._addFileChildren(
  DocumentsRouteRouteChildren,
)

interface UsersRolesRouteRouteChildren {
  UsersRolesNewRoute: typeof UsersRolesNewRoute
  UsersRolesIndexRoute: typeof UsersRolesIndexRoute
  UsersRolesIdEditRoute: typeof UsersRolesIdEditRoute
}

const UsersRolesRouteRouteChildren: UsersRolesRouteRouteChildren = {
  UsersRolesNewRoute: UsersRolesNewRoute,
  UsersRolesIndexRoute: UsersRolesIndexRoute,
  UsersRolesIdEditRoute: UsersRolesIdEditRoute,
}

const UsersRolesRouteRouteWithChildren = UsersRolesRouteRoute._addFileChildren(
  UsersRolesRouteRouteChildren,
)

interface ProjectsIdPathlessLayoutRouteChildren {
  ProjectsIdPathlessLayoutPermissionsRoute: typeof ProjectsIdPathlessLayoutPermissionsRoute
  ProjectsIdPathlessLayoutProjectProfileRoute: typeof ProjectsIdPathlessLayoutProjectProfileRoute
  ProjectsIdPathlessLayoutTasksRoute: typeof ProjectsIdPathlessLayoutTasksRoute
  ProjectsIdPathlessLayoutIndexRoute: typeof ProjectsIdPathlessLayoutIndexRoute
}

const ProjectsIdPathlessLayoutRouteChildren: ProjectsIdPathlessLayoutRouteChildren =
  {
    ProjectsIdPathlessLayoutPermissionsRoute:
      ProjectsIdPathlessLayoutPermissionsRoute,
    ProjectsIdPathlessLayoutProjectProfileRoute:
      ProjectsIdPathlessLayoutProjectProfileRoute,
    ProjectsIdPathlessLayoutTasksRoute: ProjectsIdPathlessLayoutTasksRoute,
    ProjectsIdPathlessLayoutIndexRoute: ProjectsIdPathlessLayoutIndexRoute,
  }

const ProjectsIdPathlessLayoutRouteWithChildren =
  ProjectsIdPathlessLayoutRoute._addFileChildren(
    ProjectsIdPathlessLayoutRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CategoriesRouteRoute: CategoriesRouteRouteWithChildren,
  DocumentsRouteRoute: DocumentsRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  R404Route: R404Route,
  DashboardRoute: DashboardRoute,
  LoginRoute: LoginRoute,
  MaintenanceRoute: MaintenanceRoute,
  NotAuthorizedRoute: NotAuthorizedRoute,
  ProductsRoute: ProductsRoute,
  ProfileRoute: ProfileRoute,
  SettingsRoute: SettingsRoute,
  UsersRolesRouteRoute: UsersRolesRouteRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  DevPermissionsRoute: DevPermissionsRoute,
  ProjectsNewRoute: ProjectsNewRoute,
  TemplatesNewRoute: TemplatesNewRoute,
  UsersInviteRoute: UsersInviteRoute,
  ApprovalsIndexRoute: ApprovalsIndexRoute,
  LogsIndexRoute: LogsIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  ProjectsIdPathlessLayoutRoute: ProjectsIdPathlessLayoutRouteWithChildren,
  TemplatesIdEditRoute: TemplatesIdEditRoute,
  LegalDocumentsApprovalsIndexRoute: LegalDocumentsApprovalsIndexRoute,
  LegalDocumentsTasksIndexRoute: LegalDocumentsTasksIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
